import type { OrderedMap } from '@gonfalon/immutable-shim/immutableShim';
import { useQuery } from '@tanstack/react-query';

import { getAllAccessTokens } from '#sources/AccessTokenAPI';
import type { AccessToken } from '#utils/accessTokenUtils';

export function getServiceTokensQuery() {
  return {
    queryKey: ['ServiceTokens'] as const,
    queryFn: () => getAllAccessTokens().then((res) => res.get('entities').get('accessTokens')),
  };
}

export function useServiceTokens(options?: { enabled?: boolean }) {
  return useQuery<OrderedMap<string, AccessToken>>({
    ...getServiceTokensQuery(),
    enabled: options?.enabled ?? true,
  });
}
